export const DEFAULT_UNIT_ID_DISPLAY_NAME = 'Unit ID';
export const UNIT_ID_LABEL_KEY = 'unitId';
export const WARNING_EMOJI = '⚠️';
